<template>
  <section class="customer-setting-row" :aria-label="title">
    <div class="setting-copy">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
      <span v-if="status" class="setting-status">{{ status }}</span>
    </div>
    <div class="setting-action"><slot /></div>
    <div v-if="$slots.details" class="setting-details"><slot name="details" /></div>
  </section>
</template>

<script setup lang="ts">
import type { CustomerSettingRowProps } from '@/types/Models/Company'
defineProps<CustomerSettingRowProps>()
</script>

<style scoped>
.customer-setting-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 12px 32px;
  align-items: center;
  padding: 22px 24px;
}
.customer-setting-row + .customer-setting-row {
  border-top: 1px solid #e5e9e7;
}
h4 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px;
}
p {
  font-size: 13px;
  line-height: 1.6;
  color: #59635e;
  margin: 0;
  max-width: 650px;
}
.setting-status {
  display: inline-block;
  font-size: 12px;
  margin-top: 8px;
  padding: 3px 8px;
  border-radius: 4px;
  background: #eef3f0;
  color: #344b3e;
}
.setting-action {
  display: flex;
  align-items: center;
  gap: 10px;
}
.setting-details {
  grid-column: 1 / -1;
}
@media (max-width: 600px) {
  .customer-setting-row {
    grid-template-columns: 1fr;
    padding: 18px;
    gap: 14px;
  }
  .setting-action {
    justify-content: flex-start;
  }
}
</style>
